// Copyright © Veeam Software Group GmbH

export enum Routes {
    index = 'index',
    // main
    explore = 'explore',
    restoreSessions = 'restore-sessions',
    recoveryList = 'recovery-list',
}
